import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from '@components/home/home.component';
import { PolicyListComponent } from '@components/policies/policy-list/policy-list.component';
import { PolicyDetailComponent } from '@components/policies/policy-detail/policy-detail.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'policies',
    redirectTo: 'policies/payment',
    pathMatch: 'full'
  },
  {
    path: 'policies/:family',
    component: PolicyListComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'policies/:family/:policyId',
    component: PolicyDetailComponent,
    canActivate: [MsalGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
